import './CompanyAchievements.css';
import Translator from '../../translates/Translator';
import { Row, Col } from 'react-bootstrap';
import hexes from '../../assets/img/hexes';

const CompanyAchievements = () => {
    const t = Translator();

    return (
        <div>
            <img src={hexes.h3_80} className="hex3 o-50 hex-upside" alt='' />
            <h1>{t("achievements")}</h1>
            <Row className='awards-row'>
                <Col xs={12} md={5} className='ifma-col br-4'>
                    <img src='/ifma_cz.png' alt='IFMA cz' />
                    <h5 className=''>{t("achievement1-title")}</h5>
                    <p>{t("achievement1-desc")}</p>
                    <h5 className=''>{t("achievement2-title")}</h5>
                    <p>{t("achievement2-desc")}</p>
                    <h5 className=''>{t("achievement3-title")}</h5>
                    <p>{t("achievement3-desc")}</p>
                    <h5 className=''>{t("achievement4-title")}</h5>
                    <p>{t("achievement4-desc")}</p>
                </Col>
                <Col xs={12} md={5} className='archibus-col br-4'>
                    <img src='/reference_logos/archibus_logo.png' alt='Archibus' />
                    <h5 className=''>{t("achievement5-title")}</h5>
                    <p>- {t("achievement5-desc1")}</p>
                    <p>- {t("achievement5-desc2")}</p>
                    <p>- {t("achievement5-desc3")}</p>
                </Col>
            </Row>
        </div>
    );
}

export default CompanyAchievements;